export default __webpack_public_path__ + "static/media/00.4e02a7ea.jpg";